module.exports = __webpack_public_path__ + "media/welcome_vid.f1b790a9.mp4";